/**
 * ViewOffIcon/index.js
 * desc: system icon used to hide/show password content
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ViewOffIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="view-off icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.viewOff.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 22 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M1.01 1.42L2.42 0L20.15 17.75L18.74 19.16L15.31 15.73C13.97 16.25 12.52 16.55 11 16.55C6 16.55 1.73 13.44 0 9.05C0.77 7.08 2.06 5.38 3.69 4.1L1.01 1.42ZM16 9.05C16 6.29 13.76 4.05 11 4.05C10.49 4.05 10 4.15 9.53 4.29L7.36 2.12C8.51 1.75 9.73 1.55 11 1.55C16 1.55 20.27 4.66 22 9.04C21.31 10.8 20.21 12.34 18.82 13.57L15.76 10.51C15.9 10.05 16 9.56 16 9.05ZM11 14.05C8.24 14.05 6 11.81 6 9.05C6 8.28 6.18 7.55 6.49 6.91L8.06 8.48C8.03 8.66 8 8.85 8 9.05C8 10.71 9.34 12.05 11 12.05C11.2 12.05 11.38 12.02 11.57 11.98L13.14 13.55C12.49 13.87 11.77 14.05 11 14.05ZM13.97 8.72C13.82 7.32 12.72 6.23 11.33 6.08L13.97 8.72Z" /></svg>
    </IconButton>
);


export default ViewOffIcon;
